import React, { useState, useEffect } from "react";
import { isIE, isMobile } from "react-device-detect";
import { WarningModalIE, WarningModalMobile } from "../Modals";

const LoginOverlays = () => {
  const [isUsingIEModalOpen, setIsUsingIEModalOpen] = useState(false);
  const [isUsingMobileModalOpen, setIsUsingMobileModalOpen] = useState(false);

  useEffect(() => {
    if (isIE) {
      if (!localStorage.getItem("IE")) {
        setIsUsingIEModalOpen(true);
      }
      localStorage.setItem("IE", "viewed");
    } else {
      setIsUsingIEModalOpen(false);
    }
  }, []);

  useEffect(() => {
    if (isMobile) {
      if (!localStorage.getItem("Mobile")) {
        setIsUsingMobileModalOpen(true);
      }
      localStorage.setItem("Mobile", "viewed");
    } else {
      setIsUsingMobileModalOpen(false);
    }
  }, []);

  const closeIsUsingIEModal = () => {
    setIsUsingIEModalOpen(false);
  };

  const closeIsUsingMobileModal = () => {
    setIsUsingMobileModalOpen(false);
  };

  let warningModal;

  if (isUsingIEModalOpen) {
    warningModal = <WarningModalIE show={isUsingIEModalOpen} close={closeIsUsingIEModal} />;
  } else if (isUsingMobileModalOpen) {
    warningModal = (
      <WarningModalMobile show={isUsingMobileModalOpen} close={closeIsUsingMobileModal} />
    );
  }
  return <>{warningModal}</>;
};

export default LoginOverlays;
